import { Component, input, output } from '@angular/core';
import { ToastInfo } from '../../services/case-service/case.service';

@Component({
  selector: 'app-toast',
  templateUrl: './toast.html',
  styleUrl: './toast.scss',
})
export class Toast {
  readonly toast = input<ToastInfo | null>(null);
  readonly dismissed = output<void>();

  dismiss(): void {
    this.dismissed.emit();
  }
}
